//call getEventObject with an eventCode to get the corresponding object
var eventCodes = Object.freeze({
    "login": 10001,
    "logout": 10002,
    "signup": 10003,
    "forgot_password": 10004,
    "contact_support": 10005,
    "product_selected": 11001,
    "topic_shared": 11002,
    "item_rated": 11003,
    "lesson_opened": 12001,
    "lesson_closed": 12002,
    "lesson_element_started": 12003,
    "lesson_element_ended": 12004,
    "lesson_element_paused": 12005,
    "lesson_element_pulsed": 12006,
    "test_started": 13001,
    "test_closed": 13002,
    "question_loaded": 13003,
    "question_evaluated": 13004,
    "solution_rated": 13005,
    "question_marked": 13006,
    "answer_captured": 14001,
    "question_pulsed": 14002,
    "item_viewed": 15001,
    "item_selected": 15002,
    "page_loaded": 15003,
    "purchase_viewed": 16001,
    "purchase_initiated": 16002,
    "purchase_processed": 16003,
    "profile_change_evaluated": 17001,
    "error_encountered": 18001
});

var enumSignupEventSource = Object.freeze({
    "set_password": 0,
    "send_otp": 1,
    "verify_otp": 2
});

var enumSelectedProductSource = Object.freeze({
    "home": 0,
    "dashboard": 1
});

var enumLessonSource = Object.freeze({
    "subtopic": 0,
    "recommended_lessons": 1,
    "related_lessons": 2,
    "solution_question": 3
});

var enumLessonElementType = Object.freeze({
    "video": 0,
    "act": 1,
    "interactivity": 2
});

var enumItemRatedSource = Object.freeze({
    "test": 0,
    "scorecard": 1,
    "home": 2
});

var enumViewedItemType = Object.freeze({
    "similar_problem": 0,
    "recommended_lessons": 1,
    "solution": 2
});

var enumSelectedItemType = Object.freeze({
    "topic": 0,
    "subtopic": 1
});

var enumSelectedItemSource = Object.freeze({
    "home": 0,
    "dashboard": 1
});

var enumLoadedPageType = Object.freeze({
    "marked_questions": 0,
    "solutions": 1,
    "recommendations": 2,
    "scorecard": 3
});

var enumEncounteredErrorSource = Object.freeze({
    "um": 0,
    "plp": 1
});

var objectEventDetails = Object.seal({
    "user_id": "",
    "session_id": "",
    "event_code": -1,
    "timestamp": -1
});

var eventLogin = Object.seal({
    "user_id": "",
    "login_id": "",
    "user_agent": "",
    "platform": "",
    "device": "",
    "ip_address": "",
    "result": null,
    "session_id": ""
});

var eventSignup = Object.seal({
    "name": "",
    "email": "",
    "phone": "",
    "event_source": -1,
    "result": null
});

var eventForgotPassword = Object.seal({
    "login_id": "",
    "email": "",
    "event_source": -1,
    "result": null
});

var eventProductSelected = Object.seal({
    "grade_id": -1,
    "product_type": -1,
    "source": -1
});

var eventTopicShared = Object.seal({
    "topic_id": -1
});

var eventItemRated = Object.seal({
    "subtopic_id": -1,
    "rating": -1,
    "grade_id": -1,
    "product_type": -1,
    "source": -1
});

var eventLessonOpened = Object.seal({
    "lesson_id": -1,
    "lesson_dd": -1,
    "source": -1,
    "source_id": -1,
    "snippet_id": -1,
    "question_source": -1
});

var eventLessonClosed = Object.seal({
    "lesson_id": -1
});

var eventLessonElementStarted = Object.seal({
    "lesson_id": -1,
    "lesson_dd": -1,
    "type": -1,
    "interactivity_id": -1,
    "resumed": null,
    "dd_url": ""
});

var eventLessonElementEnded = Object.seal({
    "lesson_id": -1,
    "lesson_dd": -1,
    "type": -1,
    "interactivity_id": -1
});

var eventLessonElementPaused = Object.seal({
    "lesson_id": -1,
    "lesson_dd": -1,
    "type": -1,
    "interactivity_id": -1
});

var eventLessonElementPulsed = Object.seal({
    "lesson_id": -1,
    "lesson_dd": -1,
    "type": -1,
    "interactivity_id": -1
});

var eventTestStarted = Object.seal({
    "subtopic_id": -1,
    "test_id": -1,
    "source_test_id": -1,
    "resumed": null
});

var eventTestClosed = Object.seal({
    "test_id": -1,
    "submitted": null
});

var eventQuestionLoaded = Object.seal({
    "test_id": -1,
    "snippet_id": -1,
    "question_source": -1,
    "attempt_no": -1,
    "load_duration": -1
});

var eventQuestionEvaluated = Object.seal({
    "test_id": -1,
    "snippet_id": -1,
    "question_source": -1,
    "attempt_no": -1,
    "answered": null,
    "result": null
});

var eventSolutionRated = Object.seal({
    "test_id": -1,
    "snippet_id": -1,
    "question_source": -1,
    "attempt_no": -1,
    "source": -1,
    "helpful": null
});

var eventQuestionMarked = Object.seal({
    "test_id": -1,
    "snippet_id": -1,
    "question_source": -1,
    "marked": null
});

var eventAnswerCaptured = Object.seal({
    "test_id": -1,
    "snippet_id": -1,
    "question_source": -1,
    "attempt_no": -1,
    "answer": ""
});

var eventQuestionPulsed = Object.seal({
    "test_id": -1,
    "snippet_id": -1,
    "question_source": -1,
    "attempt_no": -1
});

var eventItemViewed = Object.seal({
    "test_id": -1,
    "snippet_id": -1,
    "question_source": -1,
    "item_type": -1,
    "hidden": null
});

var eventItemSelected = Object.seal({
    "item_id": -1,
    "item_type": -1,
    "source": -1
});

var eventPageLoaded = Object.seal({
    "source_id": -1,
    "load_duration": -1,
    "page_type": -1
});

var eventPurchaseViewed = Object.seal({
    "grade_id": -1,
    "product_type": "",
    "tariff_id": -1
});

var eventPurchaseInitiated = Object.seal({
    "grade_id": -1,
    "product_type": "",
    "tariff_id": -1,
    "email": ""
});

var eventPurchaseProcessed = Object.seal({
    "grade_id": -1,
    "product_type": "",
    "tariff_id": -1,
    "result": null,
    "details": ""
});

var eventProfileChangeEvaluated = Object.seal({
    "name" : "",
    "password_changed": null,
    "result": null
});

var eventErrorEncountered = Object.seal({
    "error_id" : "",
    "status_code": -1,
    "source": -1
});

var events = Object.freeze({
    "10001": eventLogin,
    "10002": null,
    "10003": eventSignup,
    "10004": eventForgotPassword,
    "10005": null,
    "11001": eventProductSelected,
    "11002": eventTopicShared,
    "11003": eventItemRated,
    "12001": eventLessonOpened,
    "12002": eventLessonClosed,
    "12003": eventLessonElementStarted,
    "12004": eventLessonElementEnded,
    "12005": eventLessonElementPaused,
    "12006": eventLessonElementPulsed,
    "13001": eventTestStarted,
    "13002": eventTestClosed,
    "13003": eventQuestionLoaded,
    "13004": eventQuestionEvaluated,
    "13005": eventSolutionRated,
    "13006": eventQuestionMarked,
    "14001": eventAnswerCaptured,
    "14002": eventQuestionPulsed,
    "15001": eventItemViewed,
    "15002": eventItemSelected,
    "15003": eventPageLoaded,
    "16001": eventPurchaseViewed,
    "16002": eventPurchaseInitiated,
    "16003": eventPurchaseProcessed,
    "17001": eventProfileChangeEvaluated,
    "18001": eventErrorEncountered
});

var getEventObject = function(eventCode) {
    var objectEvent = {};
    var eventData = events[eventCode.toString()];
    objectEvent["event_details"] = Object.assign(objectEventDetails);
    objectEvent["event_data"] = eventData ? Object.assign(eventData) : eventData;
    objectEvent.event_details.event_code = eventCode;
    return(Object.freeze(objectEvent));
};

var allEventObj = {
    "eventCodes": eventCodes,
    "getEventObject": getEventObject,
    "enums": {
        "signupEventSource": enumSignupEventSource,
        "selectedProductSource": enumSelectedProductSource,
        "itemRatedSource": enumItemRatedSource,
        "selectedItemType": enumSelectedItemType,
        "selectedItemSource": enumSelectedItemSource,
        "lessonSource": enumLessonSource,
        "loadedPageType": enumLoadedPageType,
        "viewedItemType": enumViewedItemType,
        "encounteredErrorSource": enumEncounteredErrorSource,
        "lessonElementType": enumLessonElementType
    }
};

//export default allEventObj;//<--Uncomment for actual usage
module.exports = allEventObj;//<--Comment for actual usage


// WEBPACK FOOTER //
// ./src/model/event-structures.js